import ImageZoom from "components/imageZoom/ImageZoom";
import "./sweetSmoke.scss";
import sweetSmokeCover from "assets/img/home/sweetSmoke/sweetSmokeCover.webp";
import sweetSmoke1 from "assets/img/home/sweetSmoke/sweetSmoke1.webp";
import sweetSmoke2 from "assets/img/home/sweetSmoke/sweetSmoke2.webp";
import sweetSmoke3 from "assets/img/home/sweetSmoke/sweetSmoke3.webp";
import { SWEET_SMOKE_ID } from "constant";
import { Link, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import productStore from "store/productStore";
import cartStore from "store/cartStore";
import { useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import authStore from "store/authStore";
import ImageSlider from "../imageSlider/ImageSlider";
import imageLoadStore from "store/imageLoadStore";

const SweetSmoke = () => {
  const ImageLoadStore = imageLoadStore();
  const navigate = useNavigate();

  const ProductStore = productStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const [product, setProduct] = useState(null);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [isAddToCart, setIsAddToCart] = useState(false);

  useEffect(() => {
    fetchSpecificProductRating();
  }, []);

  const fetchSpecificProductRating = async () => {
    const product = await ProductStore.fetchOneProduct({
      _id: SWEET_SMOKE_ID,
    });
    setProduct(product);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <div className="sweet-smoke-home">
      <div className="first-container">
        <div className="image-container">
          <img src={sweetSmokeCover} alt="sweet-smoke-perfume-background" />
        </div>

        <div className="text-container">
          <div className="text-wrapper">
            <h2>Sweet Smoke</h2>
            <div className="quote-container">
              <q>Where Sweetness Meets Seduction.</q>
              <p>
                A bold fusion of sweet gourmand and smoky depth, Sweet Smoke
                blends rich coffee, delicate florals, and warm vanilla notes to
                create a sensual, long-lasting fragrance that leaves a powerful
                impression.
              </p>
            </div>
            <div className="button-container">
              <Link
                to={`/perfume/sweet-smoke/${SWEET_SMOKE_ID}/details`}
                className="link learn-more-link"
                onClick={() => {
                  ImageLoadStore.setImageLoading(true);
                }}
              >
                Learn More
              </Link>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy-now"
              >
                Buy Now
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <div className="second-container">
        <div className="left-container">
          <div className="image-container">
            <div className="left-move-container">
              <div className="left-first-image img-content">
                <ImageZoom src={sweetSmoke1} alt="sweet-smoke-first-left" />
              </div>
            </div>
            <div className="left-second-image img-content">
              <ImageZoom src={sweetSmoke2} alt="sweet-smoke-second-left" />
            </div>
          </div>
        </div>
        <div className="right-container">
          <div className="image-container">
            <div className="right-image img-content">
              <ImageZoom src={sweetSmoke3} alt="sweet-smoke-right" />
            </div>
          </div>
          <div className="quote-content">
            <q>
              Sweet gourmand perfume, sensual evening fragrance, long-lasting
              bold scent.
            </q>
          </div>
        </div>
      </div>
      <ImageSlider
        alt="sweet-smoke"
        images={[sweetSmoke1, sweetSmoke2, sweetSmoke3]}
        quoteText={
          "Sweet gourmand perfume, sensual evening fragrance, long-lasting bold scent."
        }
      />
    </div>
  );
};

export default SweetSmoke;
